import { Vue } from './plugins/vue'
const vue = new Vue

export const frameworks = [
  { name: 'vue', install: vue.install.toString().replace(/this./g, '') }
]

export default (framework?: Record<string, { name?: string; version?: string }>): unknown => {
  if (framework) {
    let i = 0
    while (i < frameworks.length) {
      if (frameworks[i].name === framework.name) {
        return frameworks[i].install
      }
      ++i
    }
  }
}